import {Link, useParams, useNavigate} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import moment from 'moment';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as Tooltip1, Legend, LineChart, Line } from 'recharts';

//import { , XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
//import { DotItemDotProps } from 'recharts/types/util/types';


import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';


class PortalServiceAnalytics extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				status: false,
				id: this.props.service,
				name: '',
			},
			djs: [],
      platforms: {
				followers: [],
				platforms: []
			},

			view: {
				charts: '',
				page: '',
			},
			sortDjs: {type: '', order: 'ASC'},
		};
    this.getAnalytics = this.getAnalytics.bind(this);
		this.setView = this.setView.bind(this);
		this.sortDjs = this.sortDjs.bind(this);
		//this.length = this.length.bind(this);
  };

  async componentDidMount() {
		

		//---- This i believe you do actaully to update on page changes!
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		const y = await value.setWorker( this.props.service );
		EventEmitter.emit('/client', y);

		this.getAnalytics();
	}

	componentWillUnmount() {
    
	}

	async getAnalytics() {
		const value = this.context;
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${value.worker[this.state.service.id]}/v3/service/analytics`, params);
		consoleLog(x.data);
		setTitle('Analytics', x.data.servicename);
		if( x.status === 200 ) {
			let service = this.state.service;
			if( service.name !== x.data.servicename || service.status === false ) {
				service.name = x.data.servicename;
				service.status = true;
				//this.setState({});
				setTitle('Analytics', x.data.servicename);
			}
      x.data.djs.sort((a, b) => a.hours < b.hours);
			for( let i in x.data.platforms.platforms ) {
				for( let j in x.data.platforms.platforms[i] ) {
					//console.log(x.data.platforms.platforms[i][j]);
					x.data.platforms.platforms[i][j].date = moment(x.data.platforms.platforms[i][j].ctime*1000).format('DD-MMM');
				}
			}
				
			this.setState({service, djs: x.data.djs, platforms: x.data.platforms, view: {charts: 'platforms', page: ''}});
		}
	}


	setView(charts, page) {
		this.setState({view: {charts, page}});
	}


	sortDjs(type) {
		let sortDjs = this.state.sortDjs;
		if( sortDjs.type === type ) {
			sortDjs.order = sortDjs.order === 'ASC' ? 'DESC' : 'ASC';
		} else {
			sortDjs.type = type;
			sortDjs.order = 'DESC';
		}
		let djs = this.state.djs;
		if( sortDjs.order === 'ASC' )
			djs = djs.toSorted((a, b) => a[type] > b[type]);
		else 
			djs = djs.toSorted((a, b) => a[type] < b[type]);
		//console.log(sortDjs, djs);
		this.setState({djs, sortDjs});
	}

	render() {
    const user = this.context;

		const followers = this.state.platforms.followers.map((e, i) => {
			return (
				<Col>
					<div class="card custom-card">
						<div class="card-body">
							<div class="d-flex align-items-center">
								<div class="me-2">
									<div class="avatar avatar-md bg-success-transparent">
										<img src={`https://cloud.ultrastream.io/images/platforms/${e.platform.toLowerCase()}.png`} alt="Platform Avatar" />
									</div>
								</div>
								<div class="flex-1">
									<a aria-label="anchor" href="javascript:void(0)" class="tx-inverse float-end text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i class="bi bi-three-dots tx-14"></i></a>
									<ul class="dropdown-menu">
										<li><a href="javascript:void(0)" class="dropdown-item border-bottom">Action</a></li>
										<li><a href="javascript:void(0)" class="dropdown-item border-bottom">Another Action</a></li>
										<li><a href="javascript:void(0)" class="dropdown-item">Something Else Here</a></li>
									</ul>
									<div class="mg-b-6">
										<p class="mb-0 tx-13 text-muted">{e.username} Followers</p>
									</div>
									<div class="flex-between">
										<h3 class="tx-20 mb-0 font-weight-normal">{e.followers}</h3>
									</div>
									<div>
										{e?.twitch_bits > 0 &&
											<>Bits {e.twitch_bits}, </>
										}
										{e?.twitch_subscribe > 0 &&
											<>Subscribers {e.twitch_subscribe}, </>
										}
										{e?.twitch_trains > 0 &&
											<>Trains {e.twitch_trains}, </>
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</Col>
			)
		});

		const CustomizedDot = (props) => {
  		//const { cx, cy, value } = props;
			const scale = 0.25;
			//console.log(props);
			if( props.cy )
				return (
					<svg xmlns="http://www.w3.org/2000/svg">
						<title>icon27.1g</title>
						<g id="train" transform={`translate(${props.cx-128*scale/2},${props.cy-128*scale/2}) scale(${scale})`}>
							<rect x="15.48" y="25.49" width="5.07" height="18.91"/>
							<path d="M114.29,82.64V67.4a19.024,19.024,0,0,0-19-19H11.95a3.009,3.009,0,0,0-3,3v7.03H55.67a2,2,0,0,1,0,4H8.95V85.64H111.29A3,3,0,0,0,114.29,82.64Z"/>
							<path d="M26.1,105.643a2.774,2.774,0,1,0,2.775,2.773A2.776,2.776,0,0,0,26.1,105.643Z"/>
							<path d="M26.1,96.99a11.425,11.425,0,1,0,11.43,11.43A11.438,11.438,0,0,0,26.1,96.99Zm0,18.2a6.774,6.774,0,1,1,6.775-6.774A6.781,6.781,0,0,1,26.1,115.19Z"/>
							<rect x="24.55" y="25.49" width="21.55" height="18.91"/>
							<rect x="76.51" y="32.22" width="13.64" height="12.18"/>
							<rect x="6.95" y="8.16" width="56.74" height="13.33" rx="3"/>
							<rect x="50.1" y="25.49" width="5.06" height="18.91"/>
							<path d="M112.49,89.64H8.95v15.8a3.02,3.02,0,0,0,1.74,2.72,15.421,15.421,0,0,1,30.84.26v.02h6.48v-.02a15.425,15.425,0,1,1,30.85,0v.02h6.48v-.02a15.425,15.425,0,1,1,30.85,0v.02h1.85a3.007,3.007,0,0,0,2.61-4.49Z"/>
							<path d="M100.76,96.99a11.425,11.425,0,1,0,11.43,11.43A11.438,11.438,0,0,0,100.76,96.99Zm0,18.2a6.774,6.774,0,1,1,6.773-6.774A6.781,6.781,0,0,1,100.763,115.19Z"/>
							<path d="M74.92,28.22H91.74a1.805,1.805,0,0,0,0-3.61H74.92a1.805,1.805,0,0,0,0,3.61Z"/>
							<path d="M100.763,105.643a2.774,2.774,0,1,0,2.773,2.773A2.776,2.776,0,0,0,100.763,105.643Z"/>
							<path d="M63.43,96.99a11.425,11.425,0,1,0,11.43,11.43A11.438,11.438,0,0,0,63.43,96.99Zm0,18.2a6.774,6.774,0,1,1,6.773-6.774A6.781,6.781,0,0,1,63.434,115.19Z"/>
							<path d="M63.434,105.643a2.774,2.774,0,1,0,2.773,2.773A2.776,2.776,0,0,0,63.434,105.643Z"/>
						</g>
					</svg>
			)
		}

		const CustomTooltip = ({ active, payload, label }) => {
			const isVisible = active && payload && payload.length;
			return (
				<div className="custom-tooltip" style={{ visibility: isVisible ? 'visible' : 'hidden', backgroundColor: '#ffffff' }}>
					{isVisible && (
						<>
							<p className="label">{`${label} : ${payload[0].value}`}</p>
							<p className="intro">Something</p>
							<p className="desc">Anything you want can be displayed here.</p>
						</>
					)}
				</div>
			);
		};
		

		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Analytics</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>
				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
              <Row>
								<Col xs={12}>
                  <div className="card custom-card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">Analytics</span>
													<p className="fs-13 text-muted mb-0">View your radio station analytics.</p>
												</div>
                      </div>
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
                  </div>
                </Col>
              </Row>
							<Row>
								{followers}
							</Row>
							<Row>
								{this.state.view.charts === 'djs' &&
									<Col xs={12}>
										<div className="card">
											<div className="card-body">
												<ButtonGroup size="sm">
													<Button onClick={()=>this.sortDjs('username')}>DJ</Button>
													<Button onClick={()=>this.sortDjs('hours')}>Hours</Button>
													<Button onClick={()=>this.sortDjs('performances')}>Performances</Button>
													<Button onClick={()=>this.sortDjs('followers')}>Followers</Button>
													<Button onClick={()=>this.sortDjs('twitch_bits')}>Twitch Bits</Button>
													<Button onClick={()=>this.sortDjs('twitch_subscribes')}>Twitch Subscribes</Button>
													<Button onClick={()=>this.sortDjs('twitch_trains')}>Twitch Trains</Button>
												</ButtonGroup>
												<BarChart
													style={{ width: '100%', maxHeight: '50vh', aspectRatio: 1.618 }}
													responsive
													data={this.state.djs}
													margin={{
														top: 20,
														right: 0,
														left: 0,
														bottom: 5,
													}}
												>
													<CartesianGrid strokeDasharray="3 3" />
													<XAxis dataKey="username" angle={-45} />
													<YAxis width="auto" />
													<Tooltip1 />
													<Legend />
													<Bar dataKey="hours" stackId="a" label={{fill: 'white'}} fill="#5585b5" background />
													<Bar dataKey="performances" stackId="a" label={{fill: 'white'}} fill="#f95959" background />
													<Bar dataKey="followers" stackId="a" label={{fill: 'white'}} fill="#79c2d0" background />
													<Bar dataKey="twitch_trains" stackId="a" label={{fill: 'white'}} fill="#ff6f3c" background />
													<Bar dataKey="twitch_bits" stackId="a" label={{fill: 'white'}} fill="#880000" background />
													<Bar dataKey="twitch_subscribe" stackId="a" label={{fill: 'white'}} fill="#ffc93c" background />
												</BarChart>
											</div>
										</div>
									</Col>
								}
								{this.state.view.charts === 'platforms' &&
									<Col xs={12}>
										<div className="card">
											<div className="card-body">
												<ButtonGroup size="sm">
													{this.state.platforms.platforms.map((e,i) => {
														return (
															<Button key={i} onClick={()=>this.setView('platforms', i)}>{moment(e[0].ctime*1000).format('MMM YY')}</Button>
														)
													})}
												</ButtonGroup>
												<LineChart
													style={{ width: '100%', maxHeight: '50vh', aspectRatio: 1.618 }}
													responsive
													data={this.state.platforms.platforms[this.state.view.page]}
													margin={{
														top: 5,
														right: 10,
														left: 0,
														bottom: 5,
													}}
												>
													<CartesianGrid strokeDasharray="3 3" />
													<XAxis dataKey="date" />
													<YAxis width="auto" />
													<Tooltip1 content={CustomTooltip} />
													<Legend />
													<Line type="monotone" dataKey="Twitch" stroke="#8884d8" dot={CustomizedDot} />
													<Line type="monotone" dataKey="Mixcloud" stroke="#82ca9d" dot={CustomizedDot} />
												</LineChart>
											</div>
										</div>
									</Col>
								}
							</Row>
            </div>
					</div>
				}
			</>
		);
	}
}

const Analytics = props => {
  const { service } = useParams();
  const navigate = useNavigate();
  return <PortalServiceAnalytics service={service} navigate={navigate} {...props} />
}
export default Analytics;